import {APIClient} from "../../base";
import {PaginationInterface} from "../../../../interfaces/PaginationInterface";
import {IntegrateInterface} from "../../../../interfaces/private/IntegrateInterface";

const IntegrateV2Api = {
    list: async (pagination: PaginationInterface) => await APIClient.get('/v2/integrate', pagination),
    detail: async (id: number) => await APIClient.get('/v2/integrate/' + id, {}),
    create: async (model: IntegrateInterface) => await APIClient.create('/v2/integrate', model),
    update: async (id: number, model: IntegrateInterface) => await APIClient.update('/v2/integrate/' + id, model),
    delete: async (id: number|string|any) => await APIClient.delete('/v2/integrate/' + id, {}),
    syncInvoice: async (params?: any) => await APIClient.post('/v2/integrate/invoice', params),
    retryInvoice: async (reference: string) => await APIClient.post(`/v2/integrate/invoice/${encodeURIComponent(reference)}/retry`, {}),
    forceImportInvoice: async (reference: string) => await APIClient.post(`/v2/integrate/invoice/${encodeURIComponent(reference)}/force`, {}),
    syncPayment: async (params?: any) => await APIClient.post('/v2/integrate/payment', params),
    syncPayout: async (params?: any) => await APIClient.post('/v2/integrate/payout', params),
    syncSubscription: async () => await APIClient.post('/v2/integrate/subscription', {}),
    syncRefund: async (params?: any) => await APIClient.post('/v2/integrate/refund', params),
};

export default IntegrateV2Api;
